import React from 'react';
import { useAuth } from '../hooks/useAuth';
import './Login.css';

interface LoginProps {
  returnUrl?: string;
}

const Login: React.FC<LoginProps> = ({ returnUrl }) => {
  const { login } = useAuth();

  const handleOidcLogin = () => {
    login('oidc', returnUrl);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logos">
            <div className="unifirst-logo-container">
              <img 
                src="/assets/logos/unifirst-sidebar-logo.png" 
                alt="UniFirst Corporation"
                className="unifirst-logo-img"
              />
            </div>
            <div className="aldo-logo-container">
              <img 
                src="/assets/logos/aldo-no-back.png" 
                alt="Scout Central logo"
                className="aldo-logo-img"
              />
              <div className="aldo-text">
                <h2>Scout Central</h2>
                <span>Your AI Assistant</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="login-options">
          <button 
            className="login-button oidc-button"
            onClick={handleOidcLogin}
          >
            <svg className="login-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5z" fill="#0066cc"/>
              <path d="M12 7v10l-7-3.5V9.5l7-2.5z" fill="#ffffff"/>
            </svg>
            Sign in with UniFirst SSO
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login; 